export const fakeDataOne = [
  {
    "date": "July 13",
    "This Week": 1900,
    "Last Week": 200,
    "amt": 2400
  },
  {
    "date": "July 14",
    "This Week": 2100,
    "Last Week": 1590,
    "amt": 2210
  },
  {
    "date": "July 15",
    "This Week": 2300,
    "Last Week": 900,
    "amt": 2290
  },
  {
    "date": "July 16",
    "This Week": 2600,
    "Last Week": 1590,
    "amt": 2000
  },
  {
    "date": "July 17",
    "This Week": 2700,
    "Last Week": 1300,
    "amt": 2181
  },
  {
    "date": "July 18",
    "This Week": 3000,
    "Last Week": 2000,
    "amt": 2500
  },
  {
    "date": "Today",
    "This Week": 3600,
    "Last Week": 2900,
    "amt": 2100
  }
]

export const fakeDataTwo = [
  {
    "date": "July 13",
    "This Week": 1800,
    "Last Week": 800,
    "amt": 2400
  },
  {
    "date": "July 14",
    "This Week": 1900,
    "Last Week": 890,
    "amt": 2210
  },
  {
    "date": "July 15",
    "This Week": 2000,
    "Last Week": 1000,
    "amt": 2290
  },
  {
    "date": "July 16",
    "This Week": 3350,
    "Last Week": 1000,
    "amt": 2000
  },
  {
    "date": "July 17",
    "This Week": 2400,
    "Last Week": 1300,
    "amt": 2181
  },
  {
    "date": "July 18",
    "This Week": 2900,
    "Last Week": 2000,
    "amt": 2500
  },
  {
    "date": "Today",
    "This Week": 3500,
    "Last Week": 2900,
    "amt": 2100
  }
]
export const fakeDataThree = [
  {
    "date": "July 13",
    "This Week": 1400,
    "Last Week": 200,
    "amt": 2400
  },
  {
    "date": "July 14",
    "This Week": 1200,
    "Last Week": 300,
    "amt": 2210
  },
  {
    "date": "July 15",
    "This Week": 1500,
    "Last Week": 400,
    "amt": 2290
  },
  {
    "date": "July 16",
    "This Week": 1400,
    "Last Week": 600,
    "amt": 2000
  },
  {
    "date": "July 17",
    "This Week": 1100,
    "Last Week": 700,
    "amt": 2181
  },
  {
    "date": "July 18",
    "This Week": 1400,
    "Last Week": 900,
    "amt": 2500
  },
  {
    "date": "Today",
    "This Week": 1200,
    "Last Week": 1000,
    "amt": 2100
  }
]

export const fakeDataFour = [
  {
    "date": "July 13",
    "This Week": 1090,
    "Last Week": 200,
    "amt": 2400
  },
  {
    "date": "July 14",
    "This Week": 1000,
    "Last Week": 200,
    "amt": 2210
  },
  {
    "date": "July 15",
    "This Week": 1100,
    "Last Week": 300,
    "amt": 2290
  },
  {
    "date": "July 16",
    "This Week": 1100,
    "Last Week": 400,
    "amt": 2000
  },
  {
    "date": "July 17",
    "This Week": 1500,
    "Last Week": 500,
    "amt": 2181
  },
  {
    "date": "July 18",
    "This Week": 1400,
    "Last Week": 600,
    "amt": 2500
  },
  {
    "date": "Today",
    "This Week": 1200,
    "Last Week": 900,
    "amt": 2100
  }
]